export function isSuggestedParticipantsTabSelected(filterParams, suggestedFilterParams) {
    return filterParams === suggestedFilterParams;
}
